// Author THQ
// Date 2025-04-09 22:39:15

class PpeDeptManagerDict {
constructor({
        id = null,
        deptId = '',
        deptName = '',
        deptManagerId = '',
        deptManagerName = '',
        remark = ''}
= {}) {
    this.id = id;
    this.deptId = deptId;
    this.deptName = deptName;
    this.deptManagerId = deptManagerId;
    this.deptManagerName = deptManagerName;
    this.remark = remark;
}
}

function newEntity() {
return new PpeDeptManagerDict();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.ppe.ppeDeptManagerDict.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'deptId',
        label: 'label.em.ppe.ppeDeptManagerDict.grid.deptId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'deptName',
        label: 'label.em.ppe.ppeDeptManagerDict.grid.deptName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'deptManagerId',
        label: 'label.em.ppe.ppeDeptManagerDict.grid.deptManagerId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'deptManagerLoginName',
        label: 'label.em.ppe.ppeDeptManagerDict.grid.deptManagerLoginName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'deptManagerNumber',
        label: 'label.em.ppe.ppeDeptManagerDict.grid.deptManagerNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'deptManagerName',
        label: 'label.em.ppe.ppeDeptManagerDict.grid.deptManagerName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.em.ppe.ppeDeptManagerDict.grid.remark',
        sortable: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    deptIdFilter : '',
    deptNameFilter : '',
    deptManagerIdFilter : '',
    deptManagerNameFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'deptNameFilter',
        label: 'label.em.ppe.ppeDeptManagerDict.filter.deptName',
        disabled: false,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"deptId":"id"}'
                }
        },
        {
        key: 'deptManagerNameFilter',
        label: 'label.em.ppe.ppeDeptManagerDict.filter.deptManagerName',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"deptManagerId":"id"}'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'deptName',
        label: 'label.em.ppe.ppeDeptManagerDict.entity.deptName',
        sortable: true,
        disabled: false,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"deptId":"id"}'
                }
        },
        {
        key: 'deptManagerName',
        label: 'label.em.ppe.ppeDeptManagerDict.entity.deptManagerName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"deptManagerId":"id"}'
                }
        },
        {
        key: 'remark',
        label: 'label.em.ppe.ppeDeptManagerDict.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {PpeDeptManagerDict, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
